import {createAsyncThunk} from "@reduxjs/toolkit";
import {apiInstanceV2} from "../../Apis/AxiosV2";
import {APPROVAL_TRACKER_SERVICE} from "../EndPoints";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

// update approval
export const UpdateApprovalTrackerFlow = createAsyncThunk(
    'approvalTrackerSection/updateApprovalTrackerFlow',
    async (params) => {
        const result = await apiInstanceV2
            .put(APPROVAL_TRACKER_SERVICE.updateApprovalTrackerFlow, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);


export const GetApprovalTrackerProgress = createAsyncThunk(
    'approvalTrackerSection/getApprovalTrackerProgress',
    async (params) => {

        const { approvalFlowId, subjectId, module } = params;

        const result = await apiInstanceV2
            .get(APPROVAL_TRACKER_SERVICE.getApprovalTrackerProgress( approvalFlowId, subjectId, module))
            .then(function (response) {
                return response;
            })
            .catch(function (error) {

                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);


export const ApproveMultipleRequestMeals = createAsyncThunk(
    'approvalTrackerSection/approveMultipleRequestMeals',
    async (params) => {
        const result = await apiInstanceV2
            .put(APPROVAL_TRACKER_SERVICE.approveMultipleRequestMeals, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
